angular.module('rjmNg.controllers').controller 'systemSummaryCtrl', [
  '$scope'
  'systemSummaryService'
  '$sce'
  'app'
  ($scope, systemSummaryService, $sce, app) ->

    $scope.tabs = [
      { title: 'Metrics', report: null }
      { title: 'Filter Sets', report: null }
      { title: 'Data Dimensions', report: null }
    ]

    systemSummaryService.metrics().then (data) ->
      $scope.tabs[0].report = data
      $scope.tabs[0].report.content = $sce.trustAsHtml(data.content)
    systemSummaryService.filtersets().then (data) ->
      $scope.tabs[1].report = data
      $scope.tabs[1].report.content = $sce.trustAsHtml(data.content)
    systemSummaryService.dimensions().then (data) ->
      $scope.tabs[2].report = data
      $scope.tabs[2].report.content = $sce.trustAsHtml(data.content)

]
